export const getLocalPartner = () => import.meta.env.VITE_APP_LOCAL_PARTNER;
